import { RelocationOrderTransportReason } from "@/api-schema-enums";

export const RELOCATION_ORDER_TRANSPORT_REASON_TRANSLATIONS = {
  [RelocationOrderTransportReason.Sold]: "fit:TransportReasonSold",
  [RelocationOrderTransportReason.TestDrive]: "fit:TransportReasonTestDrive",
  [RelocationOrderTransportReason.ChangeOfLocation]: "fit:TransportReasonChangeOfLocation",
  [RelocationOrderTransportReason.Repair]: "fit:TransportReasonRepair",
  [RelocationOrderTransportReason.DemonstrationVehicleRegistration]:
    "fit:TransportReasonDemonstrationVehicleRegistration",
  [RelocationOrderTransportReason.ChangeOfLocationZgm]: "fit:TransportReasonChangeOfLocationZgm",
  [RelocationOrderTransportReason.Delivery]: "fit:TransportReasonDelivery",
} satisfies Record<RelocationOrderTransportReason, string>;
